import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";
import aboutImg from "../assets/images/about-us.jpg";
import logo     from "../assets/images/anvika-logo.png";
import ms1      from "../assets/images/manufacture & supply-1.jpg";
import ms2      from "../assets/images/manufacture & supply-2.jpg";
import ms3      from "../assets/images/manufact & supply-3.jpg";

import {
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaIndustry,
  FaTruck, FaBoxOpen, FaShieldAlt, FaCheckCircle,
  FaAward, FaUsers, FaClock, FaStar,
} from "react-icons/fa";

const products = [
  "Stretch Film","Air Bubble Roll","Foam Sheet Roll","Dunnage Air Bags",
  "Silica Gel","BOPP Tape","Printed Tape","Ratchet Belt",
  "Cargo Lashing Belt","Truck Lashing Strap","PP Strap","PET Strap",
  "Corrugated Box","Wooden Box & Pallet","FLC Box Pallet",
  "PP Sheet & PP Box","Angle & Edge Board","Composite Cord Strap",
  "Protective Sleeves","Box Strapping Machine",
];

const whyUs = [
  { icon: <FaBoxOpen />,   title: "Wide Product Range",      text: "20+ industrial packaging products under one roof." },
  { icon: <FaIndustry />,  title: "Direct Manufacturer",     text: "We manufacture foam, PP sheets, boxes & more." },
  { icon: <FaTruck />,     title: "On-Time Delivery",        text: "Reliable supply to industries across Pune & India." },
  { icon: <FaShieldAlt />, title: "Quality Assured",         text: "All products meet industrial quality standards." },
];

const stats = [
  { icon: <FaUsers />,    value: "500+", label: "Happy Clients" },
  { icon: <FaBoxOpen />,  value: "200+", label: "Products Supplied" },
  { icon: <FaClock />,    value: "10+",  label: "Years Experience" },
  { icon: <FaStar />,     value: "99%",  label: "Satisfaction Rate" },
];

const About = () => {
  useEffect(() => { AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" }); }, []);

  return (
    <div className="about-page">

      {/* ── HERO ── */}
      <div className="about-hero" style={{ backgroundImage: `url(${aboutImg})` }}>
        <div className="about-hero-overlay">
          <span className="about-badge" data-aos="fade-down">Est. in Pune, Maharashtra</span>
          <h1 data-aos="fade-up">About Anvika Industrial Supplier</h1>
          <p data-aos="fade-up" data-aos-delay="150">
            Trusted Manufacturer &amp; Supplier of Industrial Packaging Materials
          </p>
        </div>
      </div>

      {/* ── STATS STRIP ── */}
      <section className="about-stats-strip">
        <Container>
          <Row className="justify-content-center">
            {stats.map((s, i) => (
              <Col md={3} sm={6} xs={6} key={i} data-aos="zoom-in" data-aos-delay={i * 80}>
                <div className="astat-card">
                  <div className="astat-icon">{s.icon}</div>
                  <div className="astat-value">{s.value}</div>
                  <div className="astat-label">{s.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Container className="about-container">

        {/* ── FOUNDER SECTION ── */}
        <section className="founder-section" data-aos="fade-up">
          <Row className="align-items-center g-4">
            <Col md={4} className="text-center">
              <div className="founder-logo-wrap">
                <img src={logo} alt="Anvika Logo" className="founder-logo" />
              </div>
              <div className="founder-contact-pills mt-3">
                <a href="tel:+919834430943" className="contact-pill">
                  <FaPhone /> +91 9834430943
                </a>
                <a href="mailto:anvikaind.1supplier@gmail.com" className="contact-pill">
                  <FaEnvelope /> anvikaind.1supplier@gmail.com
                </a>
              </div>
            </Col>
            <Col md={8}>
              <span className="founder-badge-tag">Founder &amp; Proprietor</span>
              <h2 className="founder-name">Mr. Vikrant Vele</h2>
              <p className="founder-desc">
                <strong>Anvika Industrial Supplier</strong> is a trusted <strong>manufacturer and supplier</strong> of
                industrial packaging materials based in Pune. Led by <strong>Mr. Vikrant Vele</strong>,
                the company has built a strong reputation for delivering quality packaging solutions
                to industries across the region.
              </p>
              <p className="founder-desc">
                With a commitment to quality and timely delivery, Anvika Industrial Supplier is your
                one-stop destination for all industrial packaging needs — from stretch films and foam
                sheets to corrugated boxes, pallets, and strapping solutions.
              </p>
              <div className="founder-checks">
                {["ISO-compliant products","Pan-India supply","Custom packaging solutions","Bulk order support"].map((c, i) => (
                  <span key={i} className="fcheck"><FaCheckCircle /> {c}</span>
                ))}
              </div>
            </Col>
          </Row>
        </section>

        {/* ── WHY CHOOSE US ── */}
        <section className="about-why-section" data-aos="fade-up">
          <h2 className="rotating-yellow-text text-center">Why Choose Us?</h2>
          <Row className="mt-4 g-3">
            {whyUs.map((w, i) => (
              <Col md={3} sm={6} key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="about-why-card">
                  <div className="awc-icon">{w.icon}</div>
                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </section>

        {/* ── IMAGE STRIP ── */}
        <section className="about-img-strip" data-aos="fade-up">
          <div className="ais-grid">
            {[ms1, ms2, ms3].map((img, i) => (
              <div className="ais-item" key={i}>
                <img src={img} alt={`about-${i}`} />
                <div className="ais-overlay" />
              </div>
            ))}
          </div>
        </section>

        {/* ── PRODUCTS WE SUPPLY ── */}
        <section className="products-list-section" data-aos="fade-up">
          <h2 className="rotating-yellow-text text-center">Products We Supply</h2>
          <p className="text-center about-sub">20+ industrial packaging products for every need</p>
          <div className="products-grid mt-4">
            {products.map((p, i) => (
              <div className="product-tag" key={i} data-aos="zoom-in" data-aos-delay={(i % 5) * 40}>
                <FaCheckCircle className="ptag-icon" /> {p}
              </div>
            ))}
          </div>
        </section>

        {/* ── ADDRESS SECTION ── */}
        <section className="address-section" data-aos="fade-up">
          <h2 className="rotating-yellow-text text-center">Our Locations</h2>
          <Row className="mt-4 g-4">
            <Col md={6}>
              <div className="address-card">
                <div className="addr-icon-wrap"><FaIndustry /></div>
                <div className="addr-body">
                  <h5>Work Address</h5>
                  <p>Gat No. 374, Satav Industrial Estate,<br />
                    Chakan Talegaon Rd, Kharabwadi,<br />
                    Chakan, Pune – 410501</p>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Satav+Industrial+Estate+Chakan+Pune"
                    target="_blank" rel="noopener noreferrer"
                    className="addr-link"
                  >
                    <FaMapMarkerAlt /> View on Map
                  </a>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="address-card">
                <div className="addr-icon-wrap office"><FaAward /></div>
                <div className="addr-body">
                  <h5>Office Address</h5>
                  <p>Stealla Tower, Moshi Alandi Rd,<br />
                    Moshi, Pune – 412105</p>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Moshi+Pune+412105"
                    target="_blank" rel="noopener noreferrer"
                    className="addr-link"
                  >
                    <FaMapMarkerAlt /> View on Map
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        {/* ── CONTACT CTA ── */}
        <section className="about-cta" data-aos="fade-up">
          <div className="about-cta-inner">
            <h3>Ready to Partner with Us?</h3>
            <p>Get in touch for bulk orders, custom packaging, or product inquiries.</p>
            <div className="about-cta-btns">
              <a href="tel:+919834430943" className="acta-btn-primary">
                <FaPhone /> Call Now
              </a>
              <a href="mailto:anvikaind.1supplier@gmail.com" className="acta-btn-outline">
                <FaEnvelope /> Email Us
              </a>
            </div>
          </div>
        </section>

      </Container>
    </div>
  );
};

export default About;
